const descMixin = {
  props: {
    field: {},
    fieldValue: "",
    checkFlag: false
  },
  data() {
    return {
      fieldObj: {}
    };
  },
  created() {
    this.fieldObj = new window.$sk.Desc(this.field);
  },
  computed: {
    descHtmlContent() {
      const extraConfig = this.fieldObj.extraConfig || {};
      const lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      // 语言键映射：zh_CN -> htmlContent, en_US -> en_us, zh_TW -> zh_tw
      if (lang === "en_US" && extraConfig.en_us) {
        return extraConfig.en_us;
      }
      if (lang === "zh_TW" && extraConfig.zh_tw) {
        return extraConfig.zh_tw;
      }
      return extraConfig.htmlContent || "";
    }
  }
};
export default descMixin;
